var map = {
	"./black/miyu.png": "gnrg",
	"./blue/miyu.png": "4gqi",
	"./white/miyu.png": "MfIk"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7AQk";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/miyu\.png$
// module id = 7AQk
// module chunks = 24